var scope_0 = require('/vercel/workpath1/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/49101a131d6bcd373afc01918521c623.js').default;export default
        Object.assign({}, scope_0 )
    